import { render } from "./PdfDocument.vue?vue&type=template&id=1b958596&scoped=true&ts=true"
import script from "./PdfDocument.vue?vue&type=script&lang=ts"
export * from "./PdfDocument.vue?vue&type=script&lang=ts"

import "./PdfDocument.vue?vue&type=style&index=0&id=1b958596&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b958596"]])

export default __exports__